import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useState } from "react";
import Input from "../../input";
import { Link } from "react-router-dom";
import Card from "../../card";
import Icon from "../../../assets/icons";
import PasswordCriteria from "../../password-criteria";
import Button from "../../button";
import { CircleLoader } from "react-spinners";

const PasswordReset = ({
  handleResetPassword,
  control,
  watch,
  loading,
}: {
  handleResetPassword: (e: any) => void;
  control: any;
  loading: boolean;
  watch: any;
}) => {
  const [viewPassword, setViewPassword] = useState(false);
  const password = watch("password", "");

  const handleShowPassword = () => {
    setViewPassword((previousValue): boolean => !previousValue);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <Card
      title="Reset Password"
      subtitle="Update your password to regain access"
    >
      <form className="mt-6 md:mt-8" onSubmit={handleResetPassword}>
        <div className="flex flex-col gap-4 md:gap-6 mb-5">
          <div className="w-full">
            <Controller
              name="password"
              control={control}
              rules={{
                required: "Password is required",
              }}
              render={({ field, fieldState }) => (
                <div className="w-full relative">
                  <Input
                    label="Password"
                    type={viewPassword ? "text" : "password"}
                    value={field.value}
                    className="w-full"
                    onChange={field.onChange}
                    autoComplete="off"
                    icon="passwordIcon"
                  />
                  <button
                    onClick={handleShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    className="w-5 h-5 absolute top-1/2 right-2 transform -translate-y-1/2 mt-4"
                    type="button"
                  >
                    <Icon
                      name={!viewPassword ? "eyecloseicon" : "eyeopenicon"}
                    />
                  </button>
                  {fieldState?.error && (
                    <p className="absolute bottom-[-18px] left-0 text-red-500 text-xs">
                      {fieldState.error.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>
          <PasswordCriteria password={password} />
        </div>
        <div className="flex flex-col justify-center items-center mt-5">
          <Button
            size="lg"
            variant="primary"
            type="submit"
            href="/signin"
            className="font-normal"
          >
            {loading ? (
              <CircleLoader color="#ffffff" loading={loading} size={20} />
            ) : (
              <div className="flex gap-3">
                Reset Password <Icon name="passwordWhiteIcon" />
              </div>
            )}
          </Button>

          <Link
            to={"/signin"}
            className="mt-2 text-[#047401] text-[16px] flex gap-2"
          >
            <Icon name="backIcon" /> Back to Sign in screen
          </Link>
        </div>
      </form>
    </Card>
  );
};

export default PasswordReset;
